import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user:null,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
  },
  actions: {
    updateUser({ commit }) {
      const userData = JSON.parse(localStorage.getItem("dataUser")) || {"idUser":null,"nombres":"","email":"","telefono":"","idRol":null,"rol":"","idPermisos":null,"opciones":[{"idOpcion":9,"nombre":"Cerrar Sesión","url":"-","icon":"mdi-logout-variant","conSubopciones":2,"subopciones":null}]};
      commit("setUser", userData);
    },
  },
  getters: {
    user(state) {
      return state.user;
    },

  },
});
